import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import FinalTreatmentPackagingTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import finalIcon from "../../../../../assets/design-revamp-company/category-icons/final-treatment-packaging-icon.svg";
const FinalTreatmentPackagingContents = ({ businessId, category }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="final-treatment-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={
            category === "Product Packaging Not Received"
              ? t("FINAL_TREATMENT_PACKAGING_NOT_RECEIVE")
              : t("FINAL_TREATMENT_PACKAGING_RECEIVE")
          }
          subDescription={
            category === "Product Packaging Not Received"
              ? t("FINAL_TREATMENT_PACKAGING_NOT_RECEIVE_DESC")
              : t("FINAL_TREATMENT_PACKAGING_RECEIVE_DESC")
          }
          isNormal={true}
          number={
            category === "Product Packaging Not Received" ? "18.2A" : "18.2B"
          }
          icon={finalIcon}
        />
      </div>
      {showTable && (
        <FinalTreatmentPackagingTable
          businessId={businessId}
          category={category}
        />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default FinalTreatmentPackagingContents;
